module.exports = {
  frame: require("./responsive-frame/responsive-frame"),
  child: require("./responsive-child/responsive-child")
};